import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/landing.css';

const Home = () => {
  return (
    <div className="landing-page">
      <header className="hero">
        <h1>Helping you make informed decisions.</h1>
        <p>Manage your content efficiently with our powerful dashboard</p>
        <div className="cta-buttons">
          <Link to="/login" className="btn-primary">
            Login
          </Link>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </header>

      <section className="features">
        <div className="feature">
          <h3>What We Do</h3>
          <p>
            We track and analyse mentions of brands, clients or industry topics in printed publications i.e Newspaper, Magazine and Journals.
          </p>
        </div>
        <div className="feature">
          <h3>How it works?</h3>
          <p>
            1. We've identified a number of publications: daily, weekly, bi-weekly, monthly etc. <br/>
            2. We gather your Keywords/Phrases you want to monitoring. <br/>
            3. Using the application upload publications. <br/>
            4. Extracting of content, using latest technological methods get article text derive sentiment. <br/>
            5. Generate Reports based on #4. <br/>
          </p>
        </div>
        <div className="feature">
          <h3>Data Analytics</h3>
          <p>
            We offer comprehensive media monitoring and analysis service, print, broadcast, online, and social media helping businesses, organizations, and individuals make informed decisions about their market strategy.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
